import { replaceLast } from "basikon-common-utils"

export function getFileNameExtension(name) {
  if (!name || typeof name !== "string") return
  return name.split(".").pop()
}

export function getFileNameWithoutExtension(name) {
  const extension = getFileNameExtension(name)
  return replaceLast(name, `.${extension}`, "")
}
